// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IGetHouseInfoWebRequest,
  TGetHouseInfoWebModel,
  IMappers,
  TGetHouseInfoWebResponse,
  IGetHouseInfoWebResponse,
  IGetHouseInfoWebResponseError,
} from './types';

export const defaultConfig: TGetHouseInfoWebModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'price-estimator',
  pathApi: '/v2/get-house-info-web/',
} as TGetHouseInfoWebModel;

export function createGetHouseInfoWebModel(parameters: IGetHouseInfoWebRequest): TGetHouseInfoWebModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetHouseInfoWebOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetHouseInfoWebRequest;
}

export async function fetchGetHouseInfoWeb<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetHouseInfoWebOptions<TResponse200, TResponse400>): Promise<
  TGetHouseInfoWebResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createGetHouseInfoWebModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetHouseInfoWebResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IGetHouseInfoWebResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetHouseInfoWebResponse;
}
